import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { loadAgencyUsage } from '~/api/data/usage/queries';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';
import { SettingsLimitsRoute } from '~/pages/settings';

export const limitsRoute: RouteObject = {
  path: 'limits',
  loader: merge({
    agencyUsage: loadAgencyUsage
  }),
  element: (
    <ProtectedRoute
      permissions={[{ resource: Resource.Subscription, action: Action.Update }]}
      redirectTo="/app/settings/usage"
    >
      <SettingsLimitsRoute />
    </ProtectedRoute>
  )
};
